var _desc, _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 810,
    height: 540,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "European flag")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M0,0v1h0.5z",
    transform: "translate(0,-1)rotate(18)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1,1)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#039",
    width: 810,
    height: 540
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    transform: "scale(30)translate(13.5,9)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: -6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: -6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(150)translate(0,6)rotate(66)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(120)translate(0,6)rotate(24)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(60)translate(0,6)rotate(12)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(30)translate(0,6)rotate(42)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    transform: "scale(-1,1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/EUR.fc2e6a53ce2e01a7f5cbcca72b8028cd.svg";
export { ForwardRef as ReactComponent };